import { FunctionComponent, createContext, useContext, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { providerErrorMessage } from '../utils'
import { GenericListSettings } from './GenericListSettings'
import { GenericListCacheProvider } from './GenericListCacheProvider'

const GenericListSettingsContext = createContext<GenericListSettings | null>(null);

export const useGenericListSettings = (): GenericListSettings => {
  const genericlistsettings = useContext(GenericListSettingsContext);

  if (!genericlistsettings) {
    throw new Error(providerErrorMessage('GenericListSettings'));
  }

  return genericlistsettings;
}

/** Wrap this around your application to be able to configure and use generic lists. 
 * Also includes GenericListCacheProvider, so no need to wrap that around your application. */
export const GenericListSettingsProvider: FunctionComponent<{ children?: React.ReactNode }> = observer(({ children }) => {
  const genericlistsettings = useMemo(() => new GenericListSettings(), []);

  return (
    <GenericListSettingsContext.Provider value={genericlistsettings}>
      <GenericListCacheProvider>
        {children}
      </GenericListCacheProvider>
    </GenericListSettingsContext.Provider>
  )
})